import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '@perval/shared';
import { Credit } from '../../models/credit';

@Component({
  selector: 'app-commande-validation',
  templateUrl: './commande-validation.component.html',
  styleUrls: ['./commande-validation.component.scss'],
})
export class CommandeValidationComponent implements OnInit {
  @Input() commande!: Credit.Commande;

  constructor(private readonly titleService: Title) {}

  ngOnInit(): void {
    this.titleService.setTitle('Validation commande | Perval.fr');
  }

  goToOrderHistory(): void {
    window.location.href = `${environment.host}/historique/consommations`;
  }
}
